import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import moment from 'moment';
import Select from '../../../components/Select';
import { getTodoWeekData, getTodoMonthData, resetViewData } from "../../../containers/Diaries/actions";
import { showDialogueBox, hideDialogueBox } from '../../../components/DialogueBox/actions';
import Icon from '../../../icons';
import DiaryCreation from "../../CreationForms/DiaryCreation";
import { StringConstants } from '../../WorkkardDetail/constants';
import DateCell from "./dateCell";

function TodoCalendar(props) {
    const monthFormat = "MMMM";
    const yearFormat = "YYYY";
    const hourFormat = "hh A";

    const [currentDate, setCurrentDate] = useState(props.selectedDate ? props.selectedDate : moment());
    const [selectedDate, setSelectedDate] = useState(props.selectedDate ? props.selectedDate : moment());
    // const [dayHiglighted, setdayHiglighted] = useState('');
    const { data } = useSelector(state => ({
        data: state.diaries.view.data,
    }), shallowEqual);

    const dispatch = useDispatch();

    useEffect(() => {
        setCurrentDate(props.selectedDate ? props.selectedDate : moment())
        setSelectedDate(props.selectedDate ? props.selectedDate : moment())
    }, [props.view])

    useEffect(() => {
        const dateFormat ='MM/DD/YYYY';
        if (props.view === 'day') {
            let startDate = moment(currentDate).startOf('week').format(dateFormat);
            let endDate = moment(currentDate).endOf('week').format(dateFormat);
            dispatch(getTodoWeekData({
                startdate: startDate,
                endDate: endDate,
                _: + new Date
            }));
        }
        else {
            const monthStart = moment(currentDate).startOf('month').format(dateFormat);
            const monthEnd = moment(monthStart).endOf('month').format(dateFormat);
            dispatch(getTodoMonthData({
                startdate: monthStart,
                endDate: monthEnd,
                _: + new Date
            }));
        }

    }, [currentDate]);

    const nextWeek = () => {
        dispatch(resetViewData());
        setCurrentDate(moment(currentDate).add(1, "week"))
        // setSelectedDate(moment(selectedDate).add(1, "week"))
    }

    const prevWeek = () => {
        dispatch(resetViewData());
        setCurrentDate(moment(currentDate).subtract(1, "week"))
        // setSelectedDate(moment(selectedDate).subtract(1, "week"))
    }

    const nextMonth = () => {
        dispatch(resetViewData());
        setCurrentDate(moment(currentDate).add(1, "month"))
        // setSelectedDate(moment(selectedDate).add(1, "month"))
    }

    const prevMonth = () => {
        dispatch(resetViewData());
        setCurrentDate(moment(currentDate).subtract(1, "month"))
        // setSelectedDate(moment(selectedDate).subtract(1, "month"))
    }

    const onDateClick = (day) => {
        setSelectedDate(day)
    }

    const onChangeMonth = (month) => {
        setCurrentDate(moment(currentDate).month(month))
        //setSelectedDate(moment(selectedDate).month(month))
    }

    const onChangeYear = (year) => {
        setCurrentDate(moment(currentDate).year(year))
        //setSelectedDate(moment(selectedDate).year(year))
    }

    const onClickToday = () => {
        setSelectedDate(moment())
        setCurrentDate(moment())
    };

    const onAddDiaryClick = () => {
        dispatch(showDialogueBox({
            flag: true,
            component: <DiaryCreation
                type={StringConstants.common}
                onClose={() => { dispatch(hideDialogueBox()) }}
                referrer={"tdo"}
            />,
            overlayClassName: "modal fullViewMain",
            contentClassName: "modalContent fullView animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: false
        }));
    };

    const header = () => {
        const months = moment.months()
        const years = [];
        let startDate = moment(currentDate).startOf('week');
        let endDate = moment(currentDate).endOf('week');

        for (let i = 1990; i < 2100; i++) {
            years.push({ label: i, value: i })
        }
        return (
            <div className="diaryHeader rowSpaceBetween" data-test="calenderHead">
                <div className="alignMiddle">
                    {
                        props.view === 'day' ?
                            <h2>
                                {
                                    moment(startDate).isSame(endDate, 'month') ?
                                        moment(startDate).format(monthFormat) + " "
                                        :
                                        `${moment(startDate).format(monthFormat)} - ${moment(endDate).format(monthFormat)} `
                                }
                                {
                                    moment(currentDate).format(yearFormat)
                                }
                            </h2>
                            :
                            <>
                                <div className="dropDown select" data-test="monthDropDown">

                                    <Select
                                        options={months.map(month => (
                                            { label: month, value: month }
                                        ))}
                                        selected={moment(currentDate).format(monthFormat)}
                                        onSelect={onChangeMonth}
                                        openOnClick={true}
                                        iconName="downArrow"
                                        styleClass=""
                                    />
                                </div>
                                <div className="dropDown select" data-test="yearDropDown">
                                    <Select
                                        options={years}
                                        selected={moment(currentDate).format(yearFormat)}
                                        onSelect={onChangeYear}
                                        openOnClick={true}
                                        styleClass=""
                                        iconName="downArrow"
                                    />
                                </div>
                            </>
                    }
                    <div className="ccCalendar alignMiddle">
                        <div className={`iconLeft ${props.view === 'day' ? 'ml__2':'ml'} `} onClick={props.view === 'day' ? prevWeek : prevMonth} data-test="prev"></div>
                        {
                            // <div className="today ml mr pointer" onClick={!moment().isSame(selectedDate, 'day') ? onClickToday : () => { return false }}>Today</div>
                            <div className="today ml mr pointer" onClick={onClickToday} data-test="today">Today</div>
                        }
                        <div className="iconRight" onClick={props.view === 'day' ? nextWeek : nextMonth} data-test="next"></div>
                    </div>
                </div>
                <div className="alignMiddle">
                    <a data-test="addDiary" title="Add diary" className="btn ripple btnSqure buttonGradient mr__1 addIcon addNoteButton" onClick={onAddDiaryClick} ><Icon name="add" className="icon white" /><span className="ml">Diary</span></a>
                </div>
            </div>
        )
    }

    const weekHead = () => {
        let startDate = moment(currentDate).startOf('week');
        let startDateOfWeekLessOne = moment(currentDate).startOf('week').subtract(1, "day");
        let endDateOfWeek = moment(currentDate).endOf('week');
        const monthStart = moment(currentDate).startOf('month');
        const monthEnd = moment(monthStart).endOf('month');
        const previousMonthDate = moment(monthStart).subtract(1, "day"); 
        const dateFormat = "D";
        let formattedDate = "";
        let days = [];
        if (props.view === 'day') days.push(<li className="alignCenter allDay" key={'allday'}></li>)

        let day = startDate;

        for (let i = 0; i < 7; i++) {
            formattedDate = moment(day).format(dateFormat)
            const cloneDay = day;
            days.push(
                <li data-test="calenderHead">
                    <span className={props.view === 'day' ? (HeaderDayHighlight(startDateOfWeekLessOne, endDateOfWeek, day) ? 'currentDay' : '')
                        : HeaderDayHighlight(previousMonthDate, monthEnd, day) ? 'currentDay' : ''}>
                        {moment(day).format("dddd")}</span>
                    {props.view === 'day' &&
                        <a onClick={() => onDateClick(cloneDay)} className={` pointer date
                        ${(moment(selectedDate).isSame(day, 'day') ? 'select' :
                                (moment().isSame(moment(day).format('YYYY-MM-DD'), 'day')) ? 'active' :
                                    'black')}`}>
                            {formattedDate}
                        </a>

                    }
                    {
                        props.view === "day" && !(moment(selectedDate).isSame(day, 'day')) && checkStatusOfDay(formattedDate, day)
                    }
                </li>
            );
            day = moment(day).add(1, 'days');
        }

        return (
            <ul className="weekDay">
                {days}
            </ul>
        )
    }

    const HeaderDayHighlight = (startDate, endDate, day) => {
        return moment(selectedDate).isBetween(startDate, endDate)
            && (moment(moment(selectedDate).day()).isSame(moment(day).day()))
    }

    const checkStatusOfDay = (formattedDate, day) => {
        const dayData = data[formattedDate];
        const comStatus = [];
        if (dayData != null) {
            for (let values in dayData) {
                if (dayData[values].length > 0) {
                    //   const anyToday = dayData[values].find((x) => isTodayDate(x.DueDate));
                    //   if (anyToday) { return null; }

                    let temp = dayData[values].every((x) => x.Status === "OPEN");
                    comStatus.push(temp);

                    const anyOverDue = dayData[values].find((x) => x.Status === "OPEN" && compareDateWithCurrentDate(x.DueDate));
                    if (anyOverDue) {
                        return <div className="dotGreen"></div>;
                    }
                    const anyOpen = dayData[values].find((x) => x.Status === "OPEN");
                    if (anyOpen) {
                        return <div className="dotRed"></div>;
                    }
                }
            }
            if (comStatus.every((flag) => flag != true)) {
                return <div className="dotGray"></div>;
            }
        }
        return null;
    };

    const compareDateWithCurrentDate = (compareDate) => {
        if (moment().isBefore(moment(compareDate).format("YYYY-MM-DD")) ||
            moment().isSame(moment(compareDate).format("YYYY-MM-DD"), "day")) {
            return true;
        } else {
            return false;
        }
    }

    const isTodayDate = (compareDate) => moment().isSame(moment(compareDate).format("YYYY-MM-DD"), "day") ? true : false;

    const monthView = () => {
        const monthStart = moment(currentDate).startOf('month');
        const monthEnd = moment(monthStart).endOf('month');
        const startDate = moment(monthStart).startOf('week');
        const endDate = moment(monthEnd).endOf('week');
        const dateFormat = "D";
        const rows = [];
        let days = [];
        let day = startDate;
        let formattedDate = "";
        while (day <= endDate) {
            for (let i = 0; i < 7; i++) {
                formattedDate = moment(day).format(dateFormat)
                const cloneDay = day;
                const className = `${moment(day).isSame(selectedDate, 'day')
                    ? "selected" : ""}`;
                const dateClass = `date ${(moment(day).isSame(monthStart, 'month') && moment(selectedDate).isSame(day, 'day')) ? 'select' :
                    (moment().isSame(moment(day).format('YYYY-MM-DD'), 'day') ? 'active' : '')}`

                days.push(
                    <li className={`${!moment(day).isSame(monthStart, 'month') ? 'disabledCalendar' : ''}`} key={day} onClick={moment(day).isSame(monthStart, 'month') ? () => onDateClick(cloneDay):undefined}>
                        <span className={`${dateClass} ${moment(day).isSame(monthStart, 'month') ? 'pointer':''}`}>{formattedDate}</span>
                        {
                            moment(day).isSame(monthStart, 'month') ?
                                <DateCell className={className} dataKey={formattedDate}
                                    onDateClick={() => onDateClick(cloneDay)}
                                    formattedDate={formattedDate}
                                    data={data[formattedDate]}
                                    dateClass={dateClass}
                                    position ={(i<=4)?'right':'left'}
                                />
                                :
                                null
                        }

                    </li>
                );
                day = moment(day).add(1, 'days');
            }
            rows.push(
                <ul key={day}>{days}</ul>
            );
            days = [];
        }
        return <>{rows}</>;
    }

    const weekView = () => {
        let startDate = moment(currentDate).startOf('week');
        const monthStart = moment(currentDate).startOf('month');
        const dateFormat = "D";
        let formattedDate = "";

        let startTime = moment(selectedDate).startOf('day');
        const rows = [];

        // for each row
        for (let i = 0; i < 24; i++) {
            let h = moment(startTime).add(i, "hours")
            let day = startDate;
            const dayRightHeader = i === 12 ? <span className="allDay">Noon</span> : <span className="allDay">{h.format("h A")}</span>;
            let days = [<li key={'h'}>{dayRightHeader}</li>]; //first cell of row with hour

            // for each cell in a row
            for (let j = 0; j < 7; j++) {
                formattedDate = moment(day).format(dateFormat)
                const cloneDay = day;
                const className = `${!moment(day).isSame(monthStart, 'month')
                    ? "" : moment(day).isSame(selectedDate, 'day')
                        ? "selected" : ""}`;
                days.push(
                    <li data-test="dateCell">
                        <DateCell className={className} dataKey={formattedDate + ',' + h.format(hourFormat)}
                            onDateClick={() => onDateClick(cloneDay)}
                            data={data[formattedDate]?.[h.format(hourFormat)]}
                            position ={(i>15)?"top":(j<=4)?'right':'left'}
                        />
                    </li>
                );
                day = moment(day).add(1, 'days');
            }

            rows.push(
                <ul key={h}> {days} </ul>
            );
        }
        return <React.Fragment>{rows}</React.Fragment>;
    }

    return (
        <div className="ccCalendarMain" data-test="diariesCalenderView">
            {header()}
            <div className={`calendarMontView ${props.view === 'day' ? 'weekView' : ''} colFlex`}>
                {weekHead()}
                {props.view === 'day' ? weekView() : monthView()}
            </div>
        </div>
    );
}

export default TodoCalendar;
